var exports = {
  "lD": "ThreadSidePanel.module__split___eC04TV",
  "QA": "ThreadSidePanel.module__splitMain___eC04TV",
  "nd": "ThreadSidePanel.module__panel___eC04TV",
  "Di": "ThreadSidePanel.module__resizeHandle___eC04TV",
  "wx": "ThreadSidePanel.module__header___eC04TV",
  "nr": "ThreadSidePanel.module__headerIcon___eC04TV",
  "qd": "ThreadSidePanel.module__headerTitle___eC04TV",
  "$s": "ThreadSidePanel.module__headerActions___eC04TV",
  "Qs": "ThreadSidePanel.module__content___eC04TV",
  "rp": "ThreadSidePanel.module__membersPopout___eC04TV",
};

module.exports = exports;
